export enum ZonesRoutesEnum{
    ZONE_LIST = 'zones-list',
    ZONE_DETAIL = 'zones-detail',
}